var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Avatar, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCustomerByIdAPI } from '../../../api/url';
import { GreenVerifiedTick, MailGrayIcon, MapGrayIcon } from '../../../assets/images';
import { MuiStack } from '../../../components';
import SkeletonLoader from '../../../components/atoms/sketeton';
import EditCustomerInfo from '../../../components/templates/editCustomerInfo';
import { EParentModuleName, defaultMobile } from '../../../constants';
import { getByIdAPI } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
import VehicleSelectCard from './vehicleCardSelect';
import { ReactComponent as NewEditIcon } from '../../../assets/images/editicon.svg';
export default function CustomerAndVehicleInfo(props) {
    var _this = this;
    var _customerData$PersonC, _customerData$PersonC2, _customerData$Person, _customerData$Person2, _customerData$Person$, _customerData$Person3, _customerData$Person$2, _customerData$Person4, _customerData$Address, _customerData$Address2, _customerData$Address3, _customerData$Address4, _customerData$Address5;
    var getNPS = props.getNPS, VehiclesDetailsList = props.VehiclesDetailsList, customerDetails = props.customerDetails, isCheckBoxVisible = props.isCheckBoxVisible, onSelectVehicle = props.onSelectVehicle, parentDocument = props.parentDocument, isServiceHistoryLabel = props.isServiceHistoryLabel, isDisabled = props.isDisabled, createAndEditFlow = props.createAndEditFlow, parentComponent = props.parentComponent, IsFromParentAPt = props.IsFromParentAPt, isFromServiceHistory = props.isFromServiceHistory, isFromFinalInspection = props.isFromFinalInspection, isOpenInDrawer = props.isOpenInDrawer;
    var _a = props.createAndEditFlow || {}, isAppointment = _a.isAppointment, isInspection = _a.isInspection, isEstimate = _a.isEstimate, isJobCard = _a.isJobCard;
    var shouldAccordionBeClosed = isAppointment === "Update" || isInspection === "Update" || isEstimate === "Update" || isJobCard === "Update" || isServiceHistoryLabel;
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var _b = useState(!isCheckBoxVisible ? VehiclesDetailsList[0] : {}), selectedVehicle = _b[0], setSelectedVehicle = _b[1];
    var _c = useState(false), isInvalidMobile = _c[0], setIsInvalidMobile = _c[1];
    var _d = useState(isInvalidMobile), editCustomer = _d[0], setEditCustomer = _d[1];
    var getCustomerInfo = useAppSelector(function (state) { return state.crud; }).getCustomerInfo;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var _e = useState(true), isShowSkeleton = _e[0], setShowSkeleton = _e[1];
    var customerData = getCustomerInfo === null || getCustomerInfo === void 0 ? void 0 : getCustomerInfo.data;
    var primaryContact = customerData === null || customerData === void 0 || (_customerData$PersonC = customerData.PersonContactPoint) === null || _customerData$PersonC === void 0 ? void 0 : _customerData$PersonC.find(function (item) { return item.ContactType === "Primary"; });
    var secondaryContact = customerData === null || customerData === void 0 || (_customerData$PersonC2 = customerData.PersonContactPoint) === null || _customerData$PersonC2 === void 0 ? void 0 : _customerData$PersonC2.find(function (item) { return item.ContactType === "Secondary"; });
    var getCustomerInfoAPI = function () { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload, _result$payload2, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'getCustomerInfo',
                        url: getCustomerByIdAPI(customerDetails ? customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId : "")
                    }))];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 || (_result$payload = _result$payload.value) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.success) {
                        setShowSkeleton(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (customerDetails !== null && customerDetails !== void 0 && customerDetails.CustomerId) {
            getCustomerInfoAPI();
        }
    }, [customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId]);
    useEffect(function () {
        if ((primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber) === defaultMobile || "" || null) {
            setIsInvalidMobile(true);
            setEditCustomer(true);
        }
        if (customerData) {
            setShowSkeleton(false);
        }
    }, [primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber]);
    var handleSelectVehicle = function (item) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setSelectedVehicle(item);
            if (onSelectVehicle) {
                onSelectVehicle(item);
            }
            return [2 /*return*/];
        });
    }); };
    var handleClickEvent = function (event) {
        event.stopPropagation();
        setEditCustomer(function (prev) { return !prev; });
    };
    var navigateToPaging = function () {
        if (parentComponent === EParentModuleName.Appointment) {
            navigate("/appointment");
        }
        if (parentComponent === EParentModuleName.Inspection) {
            navigate("/Inspection");
        }
        if (parentComponent === EParentModuleName.ServiceEstimate) {
            navigate("/serviceEstimate");
        }
        if (parentComponent === EParentModuleName.Jobcard) {
            navigate("/jobCard");
        }
        else {
            navigate(-1);
        }
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        width: "100%"
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: isDesktop ? 2 : 0
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: isOpenInDrawer ? 12 : 6
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        p: '10px 0px'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'strong',
        id: "Customer-vehicle-details"
    }, t("Customer details"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "customer-detail-card",
        direction: 'column',
        border: "1px solid ".concat(systemColor.grey),
        p: 2,
        sx: {
            borderRadius: {
                xs: '8px',
                sm: '8px',
                md: '12px',
                lg: '12px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        gap: '8px'
    }, /*#__PURE__*/ React.createElement(Avatar, {
        sx: {
            width: "40px",
            height: '40px'
        }
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: true,
        justifyContent: "flex-start"
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, !isShowSkeleton && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: true,
        sx: {
            placeSelf: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "customerNameId",
        fontWeight: 'medium'
    }, customerData !== null && customerData !== void 0 && (_customerData$Person = customerData.Person) !== null && _customerData$Person !== void 0 && _customerData$Person.GivenName || customerData !== null && customerData !== void 0 && (_customerData$Person2 = customerData.Person) !== null && _customerData$Person2 !== void 0 && _customerData$Person2.FamilyName ? "".concat((_customerData$Person$ = customerData === null || customerData === void 0 || (_customerData$Person3 = customerData.Person) === null || _customerData$Person3 === void 0 ? void 0 : _customerData$Person3.GivenName) !== null && _customerData$Person$ !== void 0 ? _customerData$Person$ : ' ', " ").concat((_customerData$Person$2 = customerData === null || customerData === void 0 || (_customerData$Person4 = customerData.Person) === null || _customerData$Person4 === void 0 ? void 0 : _customerData$Person4.FamilyName) !== null && _customerData$Person$2 !== void 0 ? _customerData$Person$2 : ' ').trim() : "-")), isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '38vw',
            height: '3vh',
            padding: "1.5px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(NewEditIcon, {
        id: "viewBtn",
        color: "#6a7682",
        cursor: "pointer",
        onClick: handleClickEvent
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            gap: '5px',
            marginBottom: '3px',
            paddingTop: 5,
            marginTop: 0
        }
    }, isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '25vw',
            height: '3vh',
            padding: "1.5px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'normal',
        fontSize: 'sm',
        color: 'text.tertiary',
        id: "mobileNo"
    }, (primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber) === defaultMobile ? "-" : primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber), (primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.IsMobileVerified) && /*#__PURE__*/ React.createElement(Avatar, {
        sx: {
            height: "12px",
            width: "12px"
        },
        id: "verified-primary-number-icon",
        src: GreenVerifiedTick,
        alt: "succesicon"
    }), /*#__PURE__*/ React.createElement(Divider, {
        orientation: "vertical",
        flexItem: true,
        sx: {
            color: '#8593A3'
        }
    }), isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '25vw',
            height: '3vh',
            padding: '1.5px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'normal',
        fontSize: 'sm',
        color: 'text.tertiary',
        id: "additionalMobileNO"
    }, (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.MobileNumber) === defaultMobile ? "-" : secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.MobileNumber), (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.IsAlternateNumberVerified) && (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.MobileNumber) !== defaultMobile && /*#__PURE__*/ React.createElement(Avatar, {
        sx: {
            height: "12px",
            width: "12px"
        },
        src: GreenVerifiedTick,
        alt: "succesicon"
    })))), /*#__PURE__*/ React.createElement("div", {
        style: {
            margin: '16px -16px 0px -16px',
            border: '0.5px solid #DEE4EB'
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        pt: '8px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            gap: '12px',
            marginBottom: '3px'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: MailGrayIcon,
        alt: "mailicon"
    }), isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '60vw',
            height: '3vh',
            padding: '1.5px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        id: "emailId",
        fontWeight: 'normal',
        fontSize: 'sm',
        color: 'text.tertiary',
        style: {
            textWrap: "pretty",
            wordBreak: "break-word"
        }
    }, (primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.Email) || '-')), /*#__PURE__*/ React.createElement(MuiStack, {
        gap: "10px",
        alignItems: 'flex-start',
        marginTop: "12px"
    }, /*#__PURE__*/ React.createElement("img", {
        src: MapGrayIcon,
        alt: "mapIcon"
    }), isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '60vw',
            height: '3vh',
            padding: '1.5px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        id: "addressId",
        fontWeight: 'normal',
        fontSize: 'sm',
        color: 'text.tertiary',
        style: {
            wordBreak: "break-all",
            textWrap: "pretty"
        }
    }, customerData !== null && customerData !== void 0 && customerData.Address && (_customerData$Address = customerData.Address[0]) !== null && _customerData$Address !== void 0 && _customerData$Address.Address1 ? [(_customerData$Address2 = customerData.Address[0]) === null || _customerData$Address2 === void 0 ? void 0 : _customerData$Address2.Address1, (_customerData$Address3 = customerData.Address[0]) === null || _customerData$Address3 === void 0 ? void 0 : _customerData$Address3.Address2, (_customerData$Address4 = customerData.Address[0]) === null || _customerData$Address4 === void 0 ? void 0 : _customerData$Address4.Address3, (_customerData$Address5 = customerData.Address[0]) === null || _customerData$Address5 === void 0 ? void 0 : _customerData$Address5.Address4].filter(function (address) { return address && address.trim() !== ''; }).join(', ') : '-'))))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: isOpenInDrawer ? 12 : 6
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        p: '10px 0px'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'strong',
        id: "Customer-vehicle-details"
    }, t("Vehicle details"))), /*#__PURE__*/ React.createElement(Grid, {
        id: "vehicle-detail-card",
        item: true,
        xs: 12
    }, VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.map(function (item, index) { /*#__PURE__*/ return React.createElement(VehicleSelectCard, {
        key: item + index,
        customerDetails: customerDetails,
        selectedVehicle: selectedVehicle,
        vehicleDetails: item,
        onSelectVehicle: function () { return handleSelectVehicle(item); },
        onDeSelectVehicle: function () {
            handleSelectVehicle("");
        },
        isCheckBoxVisible: isCheckBoxVisible,
        isServiceHistoryLabel: isServiceHistoryLabel,
        isDisabled: isDisabled,
        IsFromParentAPt: IsFromParentAPt,
        getNPS: getNPS
    }); }))))), editCustomer && /*#__PURE__*/ React.createElement(EditCustomerInfo, {
        parentDocumentName: parentDocument,
        open: editCustomer,
        onUpdateClose: function () {
            setEditCustomer(function (prev) { return !prev; });
        },
        onClose: function () {
            if (isInvalidMobile) {
                navigateToPaging();
            }
            else {
                setEditCustomer(function (eve) { return !eve; });
            }
        },
        data: customerDetails,
        isDisabled: isDisabled ? isDisabled : false,
        isInvalidMobile: isInvalidMobile,
        setEditCustomerFlag: function (value) {
            setIsInvalidMobile(value);
        },
        vehicleDetails: VehiclesDetailsList
    }));
}
